import clsx from 'clsx';
import React, { cloneElement, forwardRef, useRef } from 'react';
import CheckIcon from '@cmpkit/icon/lib/glyph/check';
import CrossIcon from '@cmpkit/icon/lib/glyph/cross';
import { Button } from '../button';
const InlineEditStateless = forwardRef(({ className, isEditing, isInvalid, isCancelOnBlurEnabled, isConfirmOnBlurDisabled, isWaiting, editView, readView, areActionButtonsHidden, buttonsContainerClassNames, confirmButtonClassName, cancelButtonClassName, shouldConfirmOnEnter, onConfirm, onCancel, onKeyDown, onEditRequested, }, ref) => {
    const isReadOnly = !editView;
    const wasFocusReceivedSinceLastBlur = useRef(false);
    const setWasFocusReceivedSinceLastBlur = (v) => (wasFocusReceivedSinceLastBlur.current = v);
    const handleWrapperClick = (e) => {
        if (!isReadOnly && !isEditing) {
            onEditRequested();
        }
        else {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    const handleWrapperBlur = () => {
        if (isCancelOnBlurEnabled && isEditing && !isReadOnly) {
            setWasFocusReceivedSinceLastBlur(false);
            setTimeout(cancelIfUnfocused, 10);
            return;
        }
        if (isReadOnly || !isEditing || isConfirmOnBlurDisabled) {
            return;
        }
        setWasFocusReceivedSinceLastBlur(false);
        setTimeout(confirmIfUnfocused, 10);
    };
    const handleWrapperFocus = () => {
        setWasFocusReceivedSinceLastBlur(true);
    };
    const confirmIfUnfocused = () => {
        if (!wasFocusReceivedSinceLastBlur.current)
            onConfirm();
    };
    const cancelIfUnfocused = () => {
        if (!wasFocusReceivedSinceLastBlur.current)
            onCancel();
    };
    const shouldRenderSpinner = isWaiting && isEditing;
    const handleConfirmClick = (event) => {
        event.preventDefault();
        onConfirm();
    };
    const handleCancelClick = (event) => {
        event.preventDefault();
        onCancel();
    };
    const renderActionButtons = () => isEditing && !areActionButtonsHidden ? (React.createElement("div", { className: clsx('inline-edit-buttons', buttonsContainerClassNames) },
        React.createElement(Button, { size: 'small', "data-testid": 'inline-edit-confirm-btn', disabled: isWaiting || isInvalid, className: clsx('inline-input-ok', confirmButtonClassName), iconBefore: React.createElement(CheckIcon, null), onClick: handleConfirmClick }),
        React.createElement(Button, { size: 'small', "data-testid": 'inline-edit-cancel-btn', className: clsx('inline-input-cancel', cancelButtonClassName), disabled: isWaiting, iconBefore: React.createElement(CrossIcon, null), onClick: handleCancelClick }))) : null;
    const handleKeyDown = (event) => {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (event.keyCode === 13) {
            onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(event);
        }
    };
    const renderReadView = () => readView;
    const renderEditView = () => {
        return shouldConfirmOnEnter
            ? cloneElement(editView, {
                onKeyDown: handleKeyDown,
            })
            : editView;
    };
    const showEditView = isEditing && !isReadOnly;
    return (React.createElement("div", { ref: ref, onBlur: handleWrapperBlur, onFocus: handleWrapperFocus, onClick: handleWrapperClick, className: clsx('inline-edit', className, {
            'inline-edit-editing': isEditing,
            'is-invalid': isInvalid,
        }) },
        showEditView ? renderEditView() : renderReadView(),
        !shouldRenderSpinner ? renderActionButtons() : null));
});
InlineEditStateless.displayName = 'InlineEditStateless';
export { InlineEditStateless };
//# sourceMappingURL=InlineEditStateless.js.map